import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from 'react';
import { PdfUploadModalUI } from '../PdfUploadModalUI/index.js';
export const PdfUploadModal = ({ isOpen, onClose, onSubmit, title = 'Upload PDF File', currentModelId, currentTargetLanguage, availableSourceLanguages, onSourceLanguageChange, onTargetLanguageChange, availableModels, onModelChange, }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [error, setError] = useState(null);
    const handleFileChange = useCallback((event) => {
        const file = event.target.files?.[0];
        if (file) {
            if (file.type !== 'application/pdf') {
                setSelectedFile(null);
                setFileName(null);
                setError('Please select a PDF file.');
                return;
            }
            const maxSizeInBytes = 20 * 1024 * 1024; // 20MB
            if (file.size > maxSizeInBytes) {
                setSelectedFile(null);
                setFileName(null);
                setError('File size cannot exceed 20MB.');
                return;
            }
            setSelectedFile(file);
            setFileName(file.name);
            setError(null);
        }
        else {
            setSelectedFile(null);
            setFileName(null);
        }
    }, []);
    const internalHandleSubmit = useCallback(() => {
        if (selectedFile && fileName) {
            const defaultSourceLanguage = availableSourceLanguages.find(lang => lang.code === 'auto')?.code ||
                (availableSourceLanguages.length > 0 ? availableSourceLanguages[0].code : 'auto');
            const params = {
                file: selectedFile,
                fileName,
                model: currentModelId,
                sourceLanguage: defaultSourceLanguage,
                targetLanguage: currentTargetLanguage,
            };
            onSubmit(params);
        }
        else {
            setError('Please select a PDF file first.');
        }
    }, [
        selectedFile,
        fileName,
        onSubmit,
        currentModelId,
        currentTargetLanguage,
        availableSourceLanguages,
    ]);
    useEffect(() => {
        if (!isOpen) {
            setSelectedFile(null);
            setFileName(null);
            setError(null);
        }
    }, [isOpen]);
    const currentSourceLanguageForUI = availableSourceLanguages.find(lang => lang.code === 'auto')?.code ||
        (availableSourceLanguages.length > 0 ? availableSourceLanguages[0].code : 'auto');
    return (_jsx(PdfUploadModalUI, { isOpen: isOpen, title: title, onClose: onClose, onSubmit: internalHandleSubmit, onFileChange: handleFileChange, selectedFileName: fileName, isSubmitDisabled: !selectedFile || !!error, currentModelId: currentModelId, currentSourceLanguage: currentSourceLanguageForUI, currentTargetLanguage: currentTargetLanguage, onSourceLanguageChange: onSourceLanguageChange, onTargetLanguageChange: onTargetLanguageChange, showLanguageSelector: true, availableModels: availableModels, onModelChange: onModelChange, showModelSelector: true, error: error }));
};
//# sourceMappingURL=PdfUploadModal.js.map